import { Box, Typography, Tooltip, IconButton, useTheme } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import profileStatsStyles from "./ProfileStats.styles";

const StatItem = ({ label, value, tooltip }) => {
  const theme = useTheme();
  const styles = profileStatsStyles(theme);

  return (
    <Box sx={styles.statItem}>
      <Typography sx={styles.label}>{label}</Typography>

      {tooltip ? (
        <Tooltip title={tooltip} arrow>
          <Box sx={styles.tooltipContainer}>
            <Typography sx={styles.tooltipValue}>{value}</Typography>
            <IconButton sx={styles.iconButton}>
              <NotificationsIcon fontSize="small" />
            </IconButton>
          </Box>
        </Tooltip>
      ) : (
        <Typography sx={styles.value}>{value}</Typography>
      )}
    </Box>
  );
};

const ProfileStats = ({ balance, discount, orderCount }) => (
  <>
    <StatItem label="Баланс" value={`${balance ?? 0} ₽`} tooltip="Пополнение доступно через оператора." />
    <StatItem label="Персональная скидка" value={`${discount ?? 0}%`} />
    <StatItem label="Заказов" value={orderCount ?? 0} />
  </>
);

export default ProfileStats;
